<template>
    <div v-show="show">
      <hp5-alert type="info" hide-alert-text :show-alert="true">
        <div>
          <span class="bold">Eye Exams</span>
          Preventive eye exams are not covered under your plan. However, exams for a medical diagnosis, such as diabetes, will be covered if the service
          takes place with an in-network provider. If you need help finding a provider, call Member Services.
        </div>
      </hp5-alert>
    </div>
</template>
  
<script setup>
      const codes = ['lsp22', 'lsp8', 'psp156', 'psp66']
      const { profile, specialties } = useFCPModel()
      const hasCoverage = computed(() => profile.value.hasAnyUnityPointCoverage)
  
      const containsCode = (codes, specialties) => {
        for (let i = 0; i < codes.length; i++) {
          const code = codes[i]
          const sp = specialties?.value?.find((s) => s.id == code)
          if (sp) return true
        }
        return false
      }
  
      const codeMatch = computed(() => containsCode(codes, specialties.value))
      const show = computed(() => hasCoverage.value && codeMatch.value)
  
</script>
<style scoped>
  .bold {
    font-weight: bold;
  }
 </style>